import isEmpty from 'lodash/isEmpty';

if (!Element.prototype.matches) {
  Element.prototype.matches = Element.prototype.msMatchesSelector
    || Element.prototype.webkitMatchesSelector;
}

if (!Element.prototype.closest) {
  // eslint-disable-next-line func-names
  Element.prototype.closest = function (s) {
    let el = this;

    do {
      if (Element.prototype.matches.call(el, s)) return el;
      el = el.parentElement || el.parentNode;
    } while (el !== null && el.nodeType === 1);
    return null;
  };
}

if (!navigator.sendBeacon) {
  // eslint-disable-next-line no-inner-declarations
  function sendBeacon(url, data, _settings) {
    const xhr = 'XMLHttpRequest' in window
      ? new XMLHttpRequest()
      : new ActiveXObject('Microsoft.XMLHTTP'); // eslint-disable-line no-undef
    xhr.open('POST', url, false);
    xhr.withCredentials = true;
    xhr.setRequestHeader('Accept', '*/*');
    if (typeof data === 'string') {
      xhr.setRequestHeader('Content-Type', 'text/plain;charset=UTF-8');
      xhr.responseType = 'text/plain';
    } else if (Object.prototype.toString.call(data) === '[object Blob]') {
      if (data.type) {
        xhr.setRequestHeader('Content-Type', data.type);
      }
    }

    if (typeof _settings === 'object') {
      // eslint-disable-next-line no-restricted-globals
      if (!isNaN(_settings.timeout)) {
        // xhr.timeout doesn't work for synchronous requests
        setTimeout(() => {
          if (xhr.readyState !== 4) {
            xhr.abort();
          }
        }, _settings.timeout);
      }
    }

    xhr.send(data);
    return true;
  }

  navigator.sendBeacon = sendBeacon;
}

export const doIEObjectFitPolyfill = (images) => {
  if ('objectFit' in document.documentElement.style !== false || isEmpty(images)) return;

  images.forEach((image) => {
    if (!image.getAttribute('data-object-fit')) return;

    (image.runtimeStyle || image.style).background = `url("${image.src}") no-repeat 50%/${image.currentStyle ? image.currentStyle['object-fit'] : image.getAttribute('data-object-fit')}`;
    image.src = `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='${image.width}' height='${image.height}'%3E%3C/svg%3E`;
    image.removeAttribute('data-object-fit');
  });
};

document.addEventListener('DOMContentLoaded', () => {
  const initialImages = document.querySelectorAll('img[data-object-fit]');
  doIEObjectFitPolyfill(initialImages);
});
